class DepartmentModel {

    constructor(id, name) {
        this.id = id;
        this.name = name;
    }

}

export default DepartmentModel